import { c as _c } from "react/compiler-runtime";
import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

// Fixed height to match ProjectBrowserItem
const ITEM_HEIGHT = 76;
export const ProjectBrowserItemSkeleton: React.FC = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      justifyContent: "space-between",
      alignItems: "center",
      height: ITEM_HEIGHT,
      p: 1.75,
      px: 2,
      borderRadius: 1.5
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      flex: 1,
      minWidth: 0
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={{
      width: 20,
      height: 20,
      flexShrink: 0
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flex: 1,
      minWidth: 0
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      flexWrap: "nowrap"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton variant="text" width="60%" height={20} sx={{
      fontSize: "0.95rem"
    }} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Stack direction="row" spacing={1.5} sx={t1}>{t2}<Stack direction="column" spacing={0.5} sx={t3}><Stack direction="row" spacing={1} sx={t4}>{t5}<Skeleton variant="rectangular" width={80} height={22} sx={{
            borderRadius: 1
          }} /></Stack></Stack></Stack>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      alignItems: "center",
      flexShrink: 0
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Skeleton variant="rectangular" width={60} height={24} sx={{
      borderRadius: 1.5
    }} />;
    t9 = <Skeleton variant="circular" width={32} height={32} />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Stack direction="row" spacing={1.5} sx={t0}>{t6}<Stack direction="row" spacing={1} sx={t7}>{t8}{t9}<Skeleton variant="rectangular" width={40} height={18} sx={{
          borderRadius: 0.75
        }} /></Stack></Stack>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};